/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TPublicSuburbanV1SaveUserEstimationScoreFactRequest,
  TPublicSuburbanV1SaveUserEstimationScoreFactModel,
  IMappers,
  TPublicSuburbanV1SaveUserEstimationScoreFactResponse,
  TPublicSuburbanV1SaveUserEstimationScoreFactResponseData200,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IErrorResponseSchema } from '../../../entities/schemas/ErrorResponseSchema';

export function createPublicSuburbanV1SaveUserEstimationScoreFactModel(
  parameters: TPublicSuburbanV1SaveUserEstimationScoreFactRequest,
): TPublicSuburbanV1SaveUserEstimationScoreFactModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'price-estimator',
    pathApi: '/suburban/v1/save-user-estimation-score-fact/',
    response: {
      200: {},
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IPublicSuburbanV1SaveUserEstimationScoreFactOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TPublicSuburbanV1SaveUserEstimationScoreFactRequest;
}

export async function fetchPublicSuburbanV1SaveUserEstimationScoreFact<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IPublicSuburbanV1SaveUserEstimationScoreFactOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TPublicSuburbanV1SaveUserEstimationScoreFactResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createPublicSuburbanV1SaveUserEstimationScoreFactModel(parameters),
    config,
  )) as FetchResponse<TPublicSuburbanV1SaveUserEstimationScoreFactResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TPublicSuburbanV1SaveUserEstimationScoreFactResponseData200, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TPublicSuburbanV1SaveUserEstimationScoreFactResponse>;
}
